import { Dictionary } from '@ngrx/entity';
import { createSelector, createSelectorFactory, resultMemoize } from '@ngrx/store';
import { isEqual } from 'lodash-es';
import { CustomDotCmsContentlet } from '../../models/contentlet/custom-dotcms-contentlet.model';
import { getDotCmsState } from '../dot-cms-store';
import { dotCmsContentletsEntityAdapter } from './dotcms-contentlets.reducer';

const getDotCmsContentlets = createSelector(getDotCmsState, state => state?.contentlets);

const getDotCmsContentletEntities = dotCmsContentletsEntityAdapter.getSelectors(getDotCmsContentlets).selectEntities;

export const getDotCmsContentletByIdentifier = (uri: string) =>
  createSelectorFactory<object, CustomDotCmsContentlet>(projector => resultMemoize(projector, isEqual))(
    getDotCmsContentletEntities,
    (state: Dictionary<CustomDotCmsContentlet>) => (!!state ? state[uri] : undefined)
  );
